import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingList() {
  const rankedComics = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 10);

  const categoryMap: Record<string, string> = {
    hanman: '韩漫',
    riman: '日漫',
    guoman: '国漫',
  };

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-1 h-5 rounded-full bg-secondary-500"></div>
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
          人气排行
        </h2>
      </div>
      <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
        {rankedComics.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100/50 transition-colors ${
              index < rankedComics.length - 1 ? 'border-b border-background-200/50' : ''
            }`}
          >
            <div className={`w-8 h-8 rounded-full flex items-center justify-center font-heading font-bold text-sm ${
              index < 3
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-200 text-foreground-500'
            }`}>
              {index + 1}
            </div>
            <img
              src={comic.cover}
              alt={comic.title}
              className="w-12 h-16 rounded object-cover object-top"
              loading="lazy"
            />
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-800 line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-3 mt-1">
                <span className="text-xs text-foreground-400">{comic.author}</span>
                <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                  {categoryMap[comic.category]}
                </span>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="flex items-center gap-1">
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-accent-500"></i>
                </div>
                <span className="text-xs text-foreground-500">
                  {(comic.views / 10000).toFixed(0)}万
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}